export default defineNuxtPlugin(() => {
  const {
    public: { isProductionBuild },
  } = useRuntimeConfig()

  // manually add the script to the DOM
  const script = document.createElement('script')

  if (isProductionBuild) {
    script.src = '/js/wa_nr.js'
  } else {
    script.src = '/js/wa_nr.dev.js'
  }

  script.async = true
  document.head.appendChild(script)
})
